"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorValues2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regeneratorValues.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
var _log = require("@/utils/log");
var _training = require("@/api/training");
var _lodash = _interopRequireDefault(require("lodash"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { showDebugLog } from '@/utils/log'

// import * as utils from '@/utils/auth'

// import moment from 'moment'

var tempTeam = [];
var _default = exports.default = {
  name: "TrainingTeam",
  components: {
    UploadExcelComponent: _index.default
  },
  directives: {
    elDragDialog: _elDragDialog.default
  },
  props: {
    parentTeams: {
      type: Array,
      default: tempTeam
    },
    internalTitle: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      myTrainingTeams: [],
      fullscreenloading: false,
      isShowResult: false,
      noOfSuccess: 0,
      noOfFail: 0,
      tableData: [],
      tableHeader: [],
      smallDrop: "smallDrop"
    };
  },
  created: function created() {
    /* no code */
    this.myTrainingTeams = this.parentTeams[0].members;
    //console.info("b:"+JSON.stringify(this.myTrainingTeams));
  },
  methods: {
    tableRowClassName: function tableRowClassName(_ref) {
      var rowIndex = _ref.rowIndex;
      if ((rowIndex + 1) % 2 === 0) {
        return "oddRow";
      }
      return "evenRow";
    },
    handleDrag: function handleDrag() {
      // this.$refs.select.blur()
    },
    openDialog: function openDialog() {
      this.tableData = [];
      this.tableHeader = [];
      this.isShowResult = false;
      this.dialogVisible = true;
    },
    handleSuccess: function handleSuccess(_ref2) {
      var results = _ref2.results,
        header = _ref2.header;
      // console.log('upload excel file-result', results)
      // console.log('upload excel file-header', results)
      this.tableData = _lodash.default.map(results, function (r) {
        return {
          trainingId: _lodash.default.trim(r.trainingId),
          email: _lodash.default.trim(_lodash.default.toLower(r.email)),
          givenName: _lodash.default.trim(r.givenName),
          familyName: _lodash.default.trim(r.familyName),
          orgName: _lodash.default.trim(r.orgName),
          jobTitle: _lodash.default.trim(r.jobTitle)
        };
      });
      this.tableHeader = header;
    },
    beforeUpload: function beforeUpload(file) {
      // console.log('upload excel file', file)
      return true;
    },
    doUpload: function doUpload() {
      if (this.tableData.length <= 0) {
        var msg = this.$i18n.t("otrTraining.msgEmptyRecord");
        (0, _log.displayPopupMessage)(msg, "error");
        return false;
      }
      var trainingId = typeof this.$route.params.id === "undefined" ? "" : this.$route.params.id;
      var oEmail = (0, _cookie.getCookie)("EMAIL");
      this.fullscreenloading = true;
      this.isShowResult = false;
      this.noOfFail = 0;
      this.noOfSuccess = 0;
      this.createAccount();
      (0, _ga.writeGaEvent)(this, "Training", "".concat(_lifehikesInitData.userEvent.training.uploadParticipant), oEmail, "Training Id: ".concat(trainingId));
    },
    createAccount: function createAccount() {
      var _this = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var token, _loop, i;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              token = (0, _cookie.getCookie)("ACCESS_TOKEN");
              _this.isShowResult = true;
              _loop = /*#__PURE__*/(0, _regenerator2.default)().m(function _loop(i) {
                return (0, _regenerator2.default)().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _context.n = 1;
                      return (0, _training.autoAddParticipant)(token, _this.tableData[i]).then(function (response) {
                        (0, _log.showDebugLog)("registerEnroll-API-OK", response.data);
                        _this.tableData[i].result = "Success";
                        _this.$set(_this.tableData, i, _this.tableData[i]);
                        (0, _log.showDebugLog)("Table content row", i);
                        _this.noOfSuccess += 1;
                      }).catch(function (error) {
                        // showDebugLog('registerEnroll-API-Fail', error.response)
                        var msg = typeof error.response === "undefined" ? error.toString() : error.response.data.message;
                        _this.noOfFail += 1;
                        _this.tableData[i].result = "Fail:" + msg;
                        _this.$set(_this.tableData, i, _this.tableData[i]);
                        // showDebugLog('registerEnroll-API-Fail', msg)
                        (0, _log.showDebugLog)("Table content row", i);
                      });
                    case 1:
                      return _context.a(2);
                  }
                }, _loop);
              });
              i = 0;
            case 1:
              if (!(i < _this.tableData.length)) {
                _context2.n = 3;
                break;
              }
              return _context2.d((0, _regeneratorValues2.default)(_loop(i)), 2);
            case 2:
              i++;
              _context2.n = 1;
              break;
            case 3:
              _context2.n = 4;
              return _this.getTeam();
            case 4:
              _this.fullscreenloading = false;
            case 5:
              return _context2.a(2);
          }
        }, _callee);
      }))();
    },
    getTeam: function getTeam() {
      var _this2 = this;
      var id = typeof this.$route.params.id === "undefined" ? "" : this.$route.params.id;
      var token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      (0, _training.getTrainingTeams)(token, id).then(function (response) {
        (0, _log.showDebugLog)("ShowTeam", response.data.rows);
        //this.myTrainingTeams = response.data.rows;
        var rows = response.data.rows;
        if (rows != null && rows.length > 0) {
          _this2.myTrainingTeams = rows[0].members;
        }
      }).catch(function (error) {
        (0, _log.showDebugLog)("GetTeam-API-error", error);
      });
    },
    EmailFormatErrorStyle: function EmailFormatErrorStyle(email) {
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !re.test(email) && email !== "" ? "error" : "";
    },
    unenroll: function unenroll(userUuid, name) {
      var _this3 = this;
      var token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      var trainingId = typeof this.$route.params.id === "undefined" ? "" : this.$route.params.id;
      this.$confirm("Are you sure you want to un-enroll this user: ".concat(name, "?"), "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(function () {
        _this3.$confirm("WARNING, this action cannot be undone. ".concat(name, " will lose all access to this event/program."), "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }).then(function () {
          (0, _training.unenrolParticipant)(token, trainingId, userUuid).then(function (response) {
            var data = response.data;
            if (data.message == "success") {
              _this3.getTeam();
              _this3.$message({
                type: "success",
                message: "Un-enroll process completed"
              });
            } else {
              _this3.$message({
                type: "error",
                message: "Un-enroll Process Fail, Reason: ".concat(data.message)
              });
            }
          }).catch(function (error) {
            _this3.$message({
              type: "error",
              message: "Un-enroll Process Fail!"
            });
            (0, _log.showDebugLog)("training-unenroll-error", error);
          });
        }).catch(function () {
          _this3.$message({
            type: "info",
            message: "Action canceled"
          });
        });
        /*
         */
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "Action canceled"
        });
      });
    },
    sort_change: function sort_change(column) {
      var newItems = this.myTrainingTeams.sort(this.sortFun(column.prop));
      //console.info(newItems)
      if (column.order === "descending") {
        newItems = newItems.reverse();
      }
      this.myTrainingTeams = newItems;
    },
    sortFun: function sortFun(attr) {
      return function (item1, item2) {
        item1 = item1[attr].toLowerCase();
        item2 = item2[attr].toLowerCase();
        if (item1 < item2) {
          return -1;
        } else if (item1 > item2) {
          return 1;
        } else {
          return 0;
        }
      };
    }
  }
};